import { Spinner } from "react-bootstrap"
import "./index.scss"

const PageLoading = () => {
  return (
    <div className={"page-loading_wrapper"}>
      <Spinner animation="border" variant="secondary" className="spinner" />
    </div>
  )
}

export default PageLoading
